/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DayOfWeek = {
    Sunday: 'Sunday',
    Monday: 'Monday',
    Tuesday: 'Tuesday',
    Wednesday: 'Wednesday',
    Thursday: 'Thursday',
    Friday: 'Friday',
    Saturday: 'Saturday'
} as const;
export type DayOfWeek = typeof DayOfWeek[keyof typeof DayOfWeek];


export function instanceOfDayOfWeek(value: any): boolean {
    for (const key in DayOfWeek) {
        if (Object.prototype.hasOwnProperty.call(DayOfWeek, key)) {
            if (DayOfWeek[key as keyof typeof DayOfWeek] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DayOfWeekFromJSON(json: any): DayOfWeek {
    return DayOfWeekFromJSONTyped(json, false);
}

export function DayOfWeekFromJSONTyped(json: any, ignoreDiscriminator: boolean): DayOfWeek {
    return json as DayOfWeek;
}

export function DayOfWeekToJSON(value?: DayOfWeek | null): any {
    return value as any;
}

export function DayOfWeekToJSONTyped(value: any, ignoreDiscriminator: boolean): DayOfWeek {
    return value as DayOfWeek;
}

